//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"AftPlane",1,"Plane",0],[0,"BasePlane",1,"Plane",0],[0,"BasicDesignMode",1,0],[0,"DrawingTemplate",0,"Features.ShipDesign.DrawingTemplateBuilder",0],[0,"EnglishScale",1,0],[0,"ForePlane",1,"Plane",0],[0,"IsEdit",1,0],[0,"MetricScale",1,0],[1,"PlatesToExpand",0,"SelectNXObjectList",0],[0,"ScaleDenominator",1,0],[0,"ScaleNumerator",1,0],[0,"Tolerance",1,0],[0,"UpperPlane",1,"Plane",0]],[],[]];
SPLM.Features.ShipDesign.ExpansionDrawingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ExpansionDrawingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ExpansionDrawingBuilder.JaExpansiondrawingbuilderMetricScale = Object.freeze({
    "S501" : "S501", "S201" : "S201", "S101" : "S101", "S51" : "S51", "S21" : "S21", "S11" : "S11", "S12" : "S12", "S15" : "S15", "S110" : "S110", "S120" : "S120", "S150" : "S150", "S1100" : "S1100", "Custom" : "Custom", "Default" : "Default"});

SPLM.Features.ShipDesign.ExpansionDrawingBuilder.JaExpansiondrawingbuilderEnglishScale = Object.freeze({
    "S81" : "S81", "S41" : "S41", "S21" : "S21", "S11" : "S11", "S12" : "S12", "S14" : "S14", "S18" : "S18", "Custom" : "Custom", "Default" : "Default"});

export default SPLM;